import { DappUI } from '@elrondnetwork/dapp-core'
import { routeNames } from 'routes'
import './ConnectInline.css'

const LoginComponentInline = () => {
    const {
        ExtensionLoginButton,
        WebWalletLoginButton,
        LedgerLoginButton,
        WalletConnectLoginButton,
    } = DappUI
    return (
        <div className="inline-connect__container">
            <div>
                <ExtensionLoginButton
                    callbackRoute={routeNames.home}
                    loginButtonText={'Extension'}
                />
            </div>
            <div>
                <WebWalletLoginButton
                    callbackRoute={routeNames.home}
                    loginButtonText={'Web wallet'}
                />
            </div>
            <div>
                <LedgerLoginButton
                    loginButtonText={'Ledger'}
                    callbackRoute={'asdfasawdawd'}
                />
            </div>
            <div>
                <WalletConnectLoginButton
                    callbackRoute={routeNames.home}
                    loginButtonText={'Maiar'}
                />
            </div>
        </div>
    )
}

export default LoginComponentInline
